import cx from 'clsx';
import { Card, Type } from 'src/components/core';
import { TextLink } from 'src/components/core/textLink.component';
import type { Heading } from 'src/types/documentation';

export interface DocumentTableOfContentsProps {
  className?: string;
  headings: Heading[];
}

export function DocumentTableOfContents({
  className,
  headings,
}: DocumentTableOfContentsProps) {
  return (
    <Card className={cx('', className)}>
      <Type component="h3" bold className="mb-2.5">
        Contents
      </Type>
      <ol className="space-y-2 text-sm">
        {headings.map((heading, index) => {
          return (
            <li key={heading.data.id}>
              <div className="flex gap-2">
                <Type
                  component="span"
                  variant="text-sm"
                  colorVariant="faded"
                  className="inline-block w-2.5"
                >
                  {index + 1}
                </Type>
                <TextLink href={`#${heading.data.id}`} className="grow">
                  {heading.value}
                </TextLink>
              </div>

              {heading.children && <SubHeadings headings={heading.children} />}
            </li>
          );
        })}
      </ol>
    </Card>
  );
}

interface SubHeadingsProps {
  className?: string;
  headings: Heading[];
}

function SubHeadings({ className, headings }: SubHeadingsProps) {
  return (
    <ul className={cx('space-y-1 text-xs mt-1 mb-1.5', className)}>
      {headings.map((heading) => {
        return (
          <li
            key={heading.data.id}
            style={{
              paddingLeft: 16 + Math.min(1, heading.depth - 2) * 8,
            }}
          >
            <TextLink href={`#${heading.data.id}`}>{heading.value}</TextLink>
            {heading.children.length > 0 && (
              <SubHeadings headings={heading.children} />
            )}
          </li>
        );
      })}
    </ul>
  );
}
